/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://phz4xhuwmrbi5odyqow3hrpxeq.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-nfho4jjytbg4nlix2sjsopt6qq",
    "aws_cognito_identity_pool_id": "us-east-1:1a46277b-3934-439c-82f8-9384b8062fe9",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_dAnUqIan4",
    "aws_user_pools_web_client_id": "1clumv00m6cnhj0hc3l332vck7",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "NAME"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": "6",
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "library-storage-e0abff91210643-dev",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
